import React, { useContext, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { PublicUsersProfileContext } from '../../../services/public-users-profile/public-users-profile.context';
import { Box, IconButton, Typography } from '@material-ui/core';
import './public-user.style.css';
import { Link } from 'react-router-dom';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/styles';
import { urlConfig } from '../../../config/urlConfig';
import CloseIcon from '@material-ui/icons/Close';
import { IoMdCopy } from 'react-icons/io';

const useStyle = makeStyles((theme) => ({
  profileBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 24,
    marginBottom: 24,
    flex: 1,
  },
  profileLinkBox: {
    marginLeft: 16,
  },
  profileLinkTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  alertDialogSlideTitle: {
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 14,
    color: theme.palette.grey[500],
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export const ContactInfo = () => {
  const classes = useStyle();
  const [open, setOpen] = useState(false);
  const { userInfo } = useContext(PublicUsersProfileContext);
  return (
    <div>
      <Link onClick={() => setOpen(true)} id='public-user-contact-info-link'>
        Contact Info
      </Link>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='xs'
      >
        <DialogTitle className={classes.alertDialogSlideTitle}>
          <Box mt={1} display='flex'>
            <Typography variant='h1' className='public-user-name-contact-info'>
              {userInfo && userInfo.first_name && userInfo.first_name}
            </Typography>
            <Typography variant='h1' className='public-user-name-contact-info'>
              {userInfo && userInfo.last_name && userInfo.last_name}
            </Typography>
          </Box>

          <IconButton
            aria-label='close'
            className={classes.closeButton}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Typography
            variant='h2'
            style={{
              fontSize: 16,
            }}
          >
            Contact Info
          </Typography>
          <Box display='flex' alignItems='center'>
            <Box className={classes.profileBox}>
              <MailOutlineIcon />

              <Box className={classes.profileLinkBox}>
                <Typography variant='h3' className={classes.profileLinkTitle}>
                  {userInfo &&
                    userInfo.first_name.charAt(0).toUpperCase() +
                      userInfo.first_name.slice(1)}
                  's Profile
                </Typography>

                <Link
                  id='public-user-profile-link'
                  onClick={() => {
                    window.open(
                      `http://${urlConfig.MIZBAN_BASE_URL}/user/profile/${
                        userInfo && userInfo.username
                      }`,
                      '_self'
                    );
                  }}
                >
                  {`${urlConfig.MIZBAN_BASE_URL}/user/profile/${
                    userInfo && userInfo.username
                  }`}
                </Link>
              </Box>
            </Box>

            <Box display='flex' >
              <IconButton
                onClick={() =>
                  navigator.clipboard.writeText(
                    `${urlConfig.MIZBAN_BASE_URL}/user/profile/${
                      userInfo && userInfo.username
                    }`
                  )
                }
              >
                <IoMdCopy size='1.5rem' />
              </IconButton>
            </Box>

          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};
